// client/src/components/admin/advertiser/AdvertiserPointAddModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserPointAddModal({ open, onClose, advertiser, onSuccess }) {
  const [points, setPoints] = useState('');
  const [memo, setMemo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setPoints('');
      setMemo('');
      setError('');
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!advertiser) return;

    setError('');

    const pointAmount = Number(points);
    if (!points || isNaN(pointAmount) || pointAmount <= 0) {
      setError('지급할 포인트를 입력해주세요. (양수만 가능)');
      return;
    }

    // 환불 처리 중인 포인트 확인
    if (advertiser.pendingRefundPoints > 0) {
      setError('환불 처리 중인 포인트가 있어 포인트를 조정할 수 없습니다.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${API_URL}/api/admin/advertiser/info/${advertiser.userId}/points/adjust`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ 
            amount: pointAmount, // 양수
            memo: memo.trim() || undefined
          })
        }
      );

      const data = await res.json();

      if (data.ok) {
        onSuccess && onSuccess();
        onClose();
      } else {
        setError(data.message || '포인트 지급에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('포인트 지급 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (!open || !advertiser) return null;

  const currentPoints = advertiser.points || 0;
  const pendingRefundPoints = advertiser.pendingRefundPoints || 0;
  const pointAmount = Number(points) || 0;
  const expectedPoints = currentPoints + pointAmount;

  return (
    <div className="advertiser-point-modal" onClick={onClose}>
      <div className="advertiser-point-modal__content" onClick={(e) => e.stopPropagation()}>
        <h3 className="advertiser-point-modal__title advertiser-point-modal__title--add">포인트 지급</h3>

        {/* 현재 포인트 표시 */}
        <div className="advertiser-point-modal__info">
          <div className="advertiser-point-modal__info-row">
            <span className="advertiser-point-modal__info-label">현재 보유 포인트:</span>
            <span className="advertiser-point-modal__info-value">{currentPoints.toLocaleString()}pt</span>
          </div>
          {pendingRefundPoints > 0 && (
            <div className="advertiser-point-modal__info-row" style={{ color: '#f57c00' }}>
              <span>환불 처리 중:</span>
              <strong>{pendingRefundPoints.toLocaleString()}pt</strong>
            </div>
          )}
        </div>

        {/* 환불 처리 중 경고 */}
        {pendingRefundPoints > 0 && (
          <div className="advertiser-point-modal__warning">
            ⚠️ 환불 처리 중인 포인트가 있어 포인트 조정이 불가능합니다.
          </div>
        )}

        {/* 지급 포인트 입력 */}
        <div className="advertiser-point-modal__form-group">
          <label className="advertiser-point-modal__label">
            지급할 포인트 <span style={{ color: '#d32f2f' }}>*</span>
          </label>
          <input
            type="number"
            value={points}
            onChange={(e) => setPoints(e.target.value)}
            placeholder="지급할 포인트를 입력하세요"
            min="1"
            disabled={pendingRefundPoints > 0}
            className="advertiser-point-modal__input"
            style={{ background: pendingRefundPoints > 0 ? '#f5f5f5' : '#fff' }}
          />
        </div>

        {/* 예상 포인트 표시 */}
        {pointAmount > 0 && pendingRefundPoints === 0 && (
          <div className="advertiser-point-modal__preview">
            <div className="advertiser-point-modal__preview-label">
              지급 후 예상 포인트
            </div>
            <div className="advertiser-point-modal__preview-value" style={{ color: '#28a745' }}>
              {expectedPoints.toLocaleString()}pt
              <span style={{ fontSize: 14, fontWeight: 400, color: '#666', marginLeft: 8 }}>
                (+{pointAmount.toLocaleString()}pt)
              </span>
            </div>
          </div>
        )}

        {/* 사유 입력 (선택) */}
        <div className="advertiser-point-modal__form-group">
          <label className="advertiser-point-modal__label">
            사유 (선택)
          </label>
          <textarea
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
            placeholder="포인트 지급 사유를 입력하세요 (선택사항)"
            rows={3}
            disabled={pendingRefundPoints > 0}
            className="advertiser-point-modal__textarea"
            style={{ background: pendingRefundPoints > 0 ? '#f5f5f5' : '#fff' }}
          />
        </div>

        {error && (
          <div className="advertiser-point-modal__error">
            {error}
          </div>
        )}

        <div className="advertiser-point-modal__actions">
          <button
            onClick={onClose}
            disabled={loading}
            className="advertiser-point-modal__button advertiser-point-modal__button--cancel"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || pendingRefundPoints > 0}
            className="advertiser-point-modal__button advertiser-point-modal__button--add"
          >
            {loading ? '처리 중...' : '지급'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdvertiserPointAddModal;

